module.exports = __webpack_public_path__ + "img/thaipost0.5f2e6e26.png";